var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"kvitto-select-modal",attrs:{"size":"lg","hide-footer":""}},[_c('KvittoTable',{attrs:{"show_connect":true,"items":_vm.kvittos},on:{"connect":_vm.connect_clicked,"download_kvitto_clicked":_vm.download_kvitto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }